module.exports = __webpack_public_path__ + "static/media/You-Down-With.81377a63.gif";